import React from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  className = '',
  label,
  error,
  id,
  ...props
}: TextareaProps) {
  const textareaId = id || props.name;
  return <div className="w-full" data-id="element-157">
      {label && <label htmlFor={textareaId} className="mb-2 block text-sm font-medium text-gray-700" data-id="element-158">
          {label}
        </label>}
      <textarea id={textareaId} className={`flex min-h-[120px] w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#8BA888] focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-red-500 focus:ring-red-500' : ''} ${className}`} {...props} data-id="element-159" />
      {error && <p className="mt-1 text-sm text-red-500" data-id="element-160">{error}</p>}
    </div>;
}